import React from "react";
import ReactDOM from "react-dom";
import { Alert } from "@mui/material";
import { Routes } from "../../../root/routes";

const InvalidIntegrationCredentialAlert = () => {
  return (
    <Alert
      severity="error"
      sx={{
        backgroundColor: "var(--color-red-200)",
        color: "var(--color-red-700)",
      }}
    >
      One or more of your automated vendors has disconnected, please visit the{" "}
      <a href={Routes.privacyCenter.integrations} target="_blank" rel="noreferrer">
        API Integrations page
      </a>{" "}
      to reconnect.
    </Alert>
  );
};

export const InvalidIntegrationCredentialBanner = () => {
  const mount = document.getElementById("top-banner");
  return ReactDOM.createPortal(<InvalidIntegrationCredentialAlert />, mount);
};
